import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { IAppState } from 'types';
import DetailsRequiredModal from 'components/details-required-modal';
import MarketScanConfirmPurchase from 'components/market-scan-confirm-purchase';
import ConfirmAction from 'components/confirm-action/ConfirmAction';
import { logoutAndClearSession } from '../../services/http-service';
import { trackEvent } from 'helpers';

interface IDispatchProps {}

export const RootModalContainer = ({ layout }: IAppState & IDispatchProps) => {
  useEffect(() => {
    if (layout.isSessionExpired === true) {
      trackEvent('Web-App-Session-Expired-Show');
    }
  }, [layout.isSessionExpired]);

  return (
    <>
      <ConfirmAction
        open={layout.isSessionExpired}
        basic
        header="Session expired"
        onConfirm={logoutAndClearSession}
        hideCancel={true}
        content="You will be logged out, please login again."
        confirmText="Ok"
      />
      <DetailsRequiredModal />
      <MarketScanConfirmPurchase />
    </>
  );
};

const mapStateToProps = (state: IAppState) => ({
  ...state,
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(RootModalContainer);
